import React from 'react';
import './Footer.css';
import logo from "../../Gemco-Website-Images/logo.png";  

const Footer = () => {
  return (
    <div className='wp_footer'>
         <div className="container">
            <ul>
              <div className="wp_footer_content">
                <li className='footer_txt'>
                  <a href="/"><img src={logo} className='footer_logo' alt="gemcome" /></a>
                </li>
               <li className='footer_txt'>
                  <a href="/">Home</a>
                </li>
              <li className="footer_txt">
                <a href="/about-us">About-us</a>
              </li>
              <li className="footer_txt">
                <a href="/services">Services</a>
              </li>
              <li className="footer_txt">
                <a href="/our-projects">Our Projects</a>
              </li>
              <li className="footer_txt">
                <a href="/contact-us">Contact US</a>
              </li>
              </div>
            </ul>
      </div>
    </div>
  )
}

export default Footer